import React, { useState, useEffect } from "react";
import { token, BASEAPIURL } from "../../env";
import CryptoJS from "crypto-js";
import gsap from "gsap";
import "bootstrap/dist/css/bootstrap.min.css";
import { IoCheckmarkCircle, IoWarning } from "react-icons/io5";

export default function CartPage() {
  const [cart, setCart] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showNotifications, setShowNotifications] = useState([]);
  const [showPaymentStoppedPopup, setShowPaymentStoppedPopup] = useState(false);
  const { guestNum, booking } = cart[0] || {};

  const {
    BookingPrice: totalBookingPrice,
    BookingDisAmount: bookingDisAmount,
    BookingTaxAmount: totalTaxAmount,
    BookingNetAmount: totalNetAmount,
    amountAfterDiscount,
  } = booking || {};

  const { payload } = cart[0] || {};

  console.log(cart, "cart", payload);

  const [memberName] = useState(sessionStorage.getItem("MemberName") || "");
  const [memberMSNO] = useState(sessionStorage.getItem("MemberMSNO") || "");
  useEffect(() => {
    const storedCart = localStorage.getItem("cart");

    if (storedCart) {
      try {
        const parsed = JSON.parse(storedCart);

        console.log(parsed?.type, "parsed");

        setCart(Array.isArray(parsed) ? parsed : [parsed]);
      } catch (err) {
        console.error("❌ Failed to parse cart from localStorage:", err);
      }
    }
    // Animate cart items on load
    gsap.from(".cart-item", { opacity: 0, y: 50, duration: 0.5, stagger: 0.2 });
  }, []);

  const consolidatedCart = cart.reduce((acc, item) => {
    const orderMainId = item.bookId || 0;

    if (!acc[orderMainId]) {
      acc[orderMainId] = {
        orderMainId,
        bookId: item.bookId,
        type: item.type || "Unknown",
        pricing: {
          base: 0,
          cgst: 0,
          sgst: 0,
          total: 0,
          tax: 0,
          disAmount: 0,
          roomRate: 0,
        },
        details: { ...item.details, BookingDates: [] },
        payload: { ...item.payload, BookingDates: [] },
      };
    }
    acc[orderMainId].pricing.base += item.pricing?.base || 0;
    acc[orderMainId].pricing.cgst +=
      item.pricing?.tax / 2 || item.pricing?.cgst || 0;
    acc[orderMainId].pricing.sgst +=
      item.pricing?.tax / 2 || item.pricing?.sgst || 0;
    acc[orderMainId].pricing.total += item.pricing?.total || 0;
    acc[orderMainId].pricing.tax += item.pricing?.tax || 0;
    acc[orderMainId].pricing.disAmount += item.pricing?.disAmount || 0;
    acc[orderMainId].pricing.roomRate += item.pricing?.roomRate || 0;

    // acc[orderMainId].pricing.base += item.pricing?.base || 0;

    if (item.payload?.BookingDate) {
      acc[orderMainId].payload.BookingDates.push(item.payload.BookingDate);
      acc[orderMainId].details.BookingDates.push(item.payload.BookingDate);
    }
    return acc;
  }, {});
  const consolidatedCartArray = Object.values(consolidatedCart);

  const grandTotal = consolidatedCartArray.reduce(
    (sum, item) =>
      sum + (item.pricing?.total || booking?.BookingNetAmount || 0),
    0,
  );
  const tax = consolidatedCartArray.reduce(
    (sum, item) => item.pricing?.tax || 0,
    0,
  );
  const disAmount = consolidatedCartArray.reduce(
    (sum, item) => item.pricing?.disAmount || 0,
    0,
  );

  const baseprice = consolidatedCartArray.reduce(
    (sum, item) => item.pricing?.base || 0,
    0,
  );
  const taxprice = consolidatedCartArray.reduce(
    (accumulator, item) => accumulator + (item.pricing?.tax || 0), // Add accumulator and current item's tax
    0, // Initial value is 0
  );

  const Selectedtype = consolidatedCartArray.reduce(
    (sum, item) => item?.type || 0,
    0,
  );
  const bookId = consolidatedCartArray.reduce(
    (sum, item) => item.bookId || 0,
    0,
  );

  const addNotification = (type, message) => {
    const id = Date.now();
    setShowNotifications((prev) => [...prev, { id, type, message }]);
    setTimeout(() => {
      setShowNotifications((prev) => prev.filter((n) => n.id !== id));
    }, 5000);
  };

  const renderNotifications = () => {
    return (
      <div className="notifications-container">
        {showNotifications.map((notification) => (
          <div
            key={notification.id}
            className={`notification notification-${notification.type}`}
          >
            <div className="notification-content">
              {notification.type === "error" && (
                <IoWarning className="notification-icon" />
              )}
              {notification.type === "success" && (
                <IoCheckmarkCircle className="notification-icon" />
              )}
              {notification.type === "warning" && (
                <IoWarning className="notification-icon" />
              )}
              <span>{notification.message}</span>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const encrypt = (plainText, key) => {
    try {
      const encrypted = CryptoJS.AES.encrypt(
        CryptoJS.enc.Utf8.parse(plainText),
        CryptoJS.enc.Utf8.parse(key),
        {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7,
        },
      );
      return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    } catch (err) {
      console.error("Encryption error:", err);
      alert("Failed to encrypt payment data.");
      return null;
    }
  };

  const handleLawnAvailabilityCheck = async () => {
    setLoading(true);

    let booking = consolidatedCartArray[0]?.payload?.BookingDtl[0];
    try {
      const res = await fetch(
        `${BASEAPIURL}/GetLawnAvailability?EDate=${booking?.EventDate
        }&Type=Lawn&LawnID=${booking?.LawnID}&Token=${encodeURIComponent(
          token,
        )}`,
        { method: "GET" },
      );
      const result = await res.json();

      let availabelSlots = result?.data
        ?.filter((item) => item?.Status == "Available")
        ?.map((item) => item?.Slot_ID);

      const AvailableCartArray =
        consolidatedCartArray[0]?.payload?.BookingDtl?.filter((booking) => {
          return availabelSlots?.includes(booking?.SlotID);
        });
      const NotAvailableCartArray =
        consolidatedCartArray[0]?.payload?.BookingDtl?.filter((booking) => {
          return !availabelSlots?.includes(booking?.SlotID);
        });

      if (!(AvailableCartArray?.length > 0)) {
        alert(`❌ No Lawn Booking Available On Selected Dates and Slots`);
        return false;
      } else if (
        NotAvailableCartArray?.length > 0 &&
        AvailableCartArray?.length > 0
      ) {
        alert(`❌ No Lawn Booking Available in some Slots`);
        return false;
      } else if (!(NotAvailableCartArray?.length > 0)) {
        return true;
      }
    } catch (err) {
      console.log(err);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitBookingApi = async () => {
    try {
      const response = await fetch(`${BASEAPIURL}/InsertHealthBooking`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          tokenData: token,
          booking,
        }),
      });
      const result = await response.json();

      if (result.status === true) {
        addNotification("success", "Booking confirmed successfully!");

        return { bookingID: result.HealtBookingID };
      } else {
        addNotification("error", result.message || "Booking failed.");
      }
    } catch (error) {
      console.error(error);
      addNotification("error", "API Error");
    }
  };

  const handleSubmitRoomBooking = async () => {
    try {
      const res = await fetch(`${BASEAPIURL}/InsertRoomBooking`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tokenData: token, RBooking: payload }),
      });
      const result = await res.json();

      if (result.status === true) {
        addNotification("success", "Booking confirmed successfully!");

        return { roomBookingID: result.BookID };
      } else {
        addNotification("error", result.message || "Booking failed.");
      }
    } catch (err) {
      console.error(err);
      addNotification("error", "API Error");
    }
  };

  /* ============================================================
   * 🚧 TEMPORARILY DISABLED — PAYMENT SYSTEM (MAINTENANCE MODE)
   * Uncomment the block below and remove the real function body
   * to put the site back into maintenance mode.
   * ============================================================

  const handleEazypayPayment_MAINTENANCE = async () => {
    setShowPaymentStoppedPopup(true);
    return;
  };

  ============================================================ */

  const handleEazypayPayment = async () => {

  // const bookId = consolidatedCartArray[0]?.orderMainId || 0;
  //   let bookingID = null;
  //   console.log(bookingID,"bookingID",bookId, consolidatedCartArray)
  //   if (consolidatedCartArray[0]?.type === "Lawn") {
  //     const available = await handleLawnAvailabilityCheck();
  //     if (!available) {
  //       return;
  //     }else{
  //        bookingID = bookId;
  //        console.log(bookingID,"book");
  //     }
  //   }

    const bookId = consolidatedCartArray[0]?.orderMainId || 0;
    let bookingID = null;

    console.log("Initial", bookingID, bookId);

    if (consolidatedCartArray[0]?.type?.toLowerCase() === "lawn") {
      const available = await handleLawnAvailabilityCheck();
      if (!available) {
        return;
      }
      bookingID = bookId;
    }

    console.log("Final bookingID:", bookingID);

    if (consolidatedCartArray[0]?.type === "Health") {
      const response = await handleSubmitBookingApi();
      if (!response?.bookingID) {
        console.warn("No BookingID returned; cart not updated.");
        return;
      }
      bookingID = response.bookingID;
    }

    let roomBookingID = null;
    if (consolidatedCartArray[0]?.type === "Room") {
      const response = await handleSubmitRoomBooking();
      if (!response?.roomBookingID) {
        console.warn("No BookingID returned; cart not updated.");
        return;
      }
      roomBookingID = response.roomBookingID;
    }

    setLoading(true);
    try {
      const payments = consolidatedCartArray.map((item) => ({
        OrderType: item.type || "Unknown",
        OrderMemberID:
          item.payload?.Member_ID ||
          item.payload?.MemberID ||
          booking?.MemberID ||
          0,
        OrderDate:
          item.payload?.BookingDate ||
          new Date().toISOString() ||
          new Date(booking?.BookingDate).toISOString().split("T")[0],
        OrderTypeID: item.payload?.OrderTypeID
          ? parseInt(item.payload.OrderTypeID)
          : 0,
        OrderMainID:
          item.payload.BookID ||
          item.payload.bookId ||
          bookingID ||
          roomBookingID ||
          0,
        PaidAmount: item.pricing?.total | booking?.BookingNetAmount || 0,
        RequestAmount: item.pricing?.total | booking?.BookingNetAmount || 0,
        BookingDates: item.payload?.BookingDates || [],
      }));

      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        tokenData: token,
        Payment: payments.length === 1 ? payments[0] : payments,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      console.log(requestOptions, "Payment");
      const response = await fetch(
        `${BASEAPIURL}/InsertPaymentOrder`,
        requestOptions,
      );

      const result = await response.text();
      console.log("InsertPaymentOrder Response:", result);

      if (response.ok) {
        let responseObject;
        try {
          responseObject = JSON.parse(result);
        } catch (e) {
          const match = result.match(/"OrderID"\s*:\s*"([^"]+)"/);
          if (match) {
            responseObject = { OrderID: match[1] };
          } else {
            throw new Error("Could not parse OrderID from response");
          }
        }
        const finalOrderID = responseObject?.OrderID;

        if (finalOrderID) {
          alert(`Redirecting to payment gateway. Order ID: ${finalOrderID}`);
          // const merchantId = "142716";
          const merchantId = "127787";
          const subMerchantId = "11";
          const paymode = "9";
          const referenceNo = `${finalOrderID}`;
          const transactionAmount = grandTotal.toFixed(2);
          const mandatoryfields = `${referenceNo}|${subMerchantId}|${grandTotal.toFixed(2)}`;
          const optionalFields = `${memberName}|${memberMSNO}|${0}`;
          const returnurl = `https://jaiclub.in/PaymentIntegration`;

          // const encryptionKey = "1400010227105020";
          const encryptionKey = "1267642077805600";

          const encMandatoryFields = encrypt(mandatoryfields, encryptionKey);
          const encOptional = encrypt(optionalFields, encryptionKey);
          const encReturnUrl = encrypt(returnurl, encryptionKey);
          const encReferenceNo = encrypt(referenceNo, encryptionKey);
          const encSubMerchantId = encrypt(subMerchantId, encryptionKey);
          const encPGAmount = encrypt(transactionAmount, encryptionKey);
          const encPaymode = encrypt(paymode, encryptionKey);

          if (
            !encMandatoryFields ||
            !encReferenceNo ||
            !encSubMerchantId ||
            !encPGAmount ||
            !encReturnUrl
          ) {
            alert("❌ Encryption failed. Cannot proceed to payment.");
            setLoading(false);
            return;
          }

          const baseUrl = "https://eazypay.icicibank.com/EazyPG";

          const params =
            `merchantid=${merchantId}` +
            `&mandatory fields=${encodeURIComponent(encMandatoryFields)}` +
            `&optional fields=${encOptional}` +
            `&returnurl=${encReturnUrl}` +
            `&Reference No=${encReferenceNo}` +
            `&submerchantid=${encSubMerchantId}` +
            `&transaction amount=${encPGAmount}` +
            `&paymode=${encPaymode}`;
          const plainparams =
            `merchantid=${merchantId}` +
            `&mandatory fields=${mandatoryfields}` +
            `&optional fields=${optionalFields}` +
            `&returnurl=${returnurl}` +
            `&Reference No=${referenceNo}` +
            `&submerchantid=${subMerchantId}` +
            `&transaction amount=${transactionAmount}` +
            `&paymode=${paymode}`;

          const encryptedUrl = `${baseUrl}?${params}`;
          const plainurl = `${baseUrl}?${plainparams}`;
          console.log("🔒 Encrypted Eazypay URL (GET):", encryptedUrl);
          console.log("Plain Eazypay URL (GET):", plainurl);

          window.location.href = encryptedUrl;
          localStorage.removeItem("cart");
        } else {
          alert("✅ Payment request sent, but OrderID not found in response.");
        }
      } else {
        alert("❌ Payment request failed.");
      }
    } catch (error) {
      console.error("Payment Error:", error);
      alert("⚠️ An error occurred during payment initiation.");
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = (orderMainId) => {
    const updated = cart.filter((item) => item.bookId !== orderMainId);
    setCart(updated);
    localStorage.setItem("cart", JSON.stringify(updated));
    gsap.to(`.cart-item-${orderMainId}`, {
      opacity: 0,
      y: -50,
      duration: 0.5,
      onComplete: () => {
        gsap.set(`.cart-item-${orderMainId}`, { display: "none" });
      },
    });
  };

  const handleClear = () => {
    setCart([]);
    localStorage.removeItem("cart");
    gsap.to(".cart-item", { opacity: 0, y: -50, duration: 0.5, stagger: 0.1 });
  };

  const formatPrice = (amount) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
    }).format(amount);

  if (consolidatedCartArray.length === 0) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
        <div className="text-center p-5 bg-white rounded shadow">
          <h3 className="mb-4">Your cart is empty</h3>
          <button
            onClick={() => (window.location.href = "/dashboard")}
            className="btn btn-primary"
          >
            Continue Shopping
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-vh-100 bg-light py-4">
      <div className="container">
        {renderNotifications()}

        {/* ── Payment Maintenance Popup ── */}
        {showPaymentStoppedPopup && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "rgba(20, 8, 8, 0.82)",
              backdropFilter: "blur(5px)",
              animation: "fadeInOverlay 0.25s ease",
            }}
            onClick={() => setShowPaymentStoppedPopup(false)}
          >
            <div
              style={{
                background: "linear-gradient(160deg, #44282e 0%, #2b1a1d 100%)",
                border: "1.5px solid #ffffffff",
                borderRadius: "18px",
                padding: "44px 40px 36px",
                maxWidth: "420px",
                width: "90%",
                boxShadow: "0 25px 60px rgba(0,0,0,0.7), 0 0 35px rgba(173,125,82,0.15)",
                textAlign: "center",
                position: "relative",
                animation: "slideUpPopup 0.3s cubic-bezier(0.34,1.56,0.64,1)",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Icon circle */}
              {/* <div
                style={{
                  width: "72px",
                  height: "72px",
                  borderRadius: "50%",
                  background: "#2b1a1d",
                  border: "2px solid #ffffffff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  boxShadow: "0 8px 24px rgba(173,125,82,0.3)",
                  fontSize: "30px",
                }}
              >
                🔧
              </div> */}

              {/* Title */}
              <h4
                style={{
                  color: "#d5bdaf",
                  fontWeight: 700,
                  fontSize: "1.35rem",
                  marginBottom: "10px",
                  letterSpacing: "0.5px",
                  fontFamily: "'Josefin Sans', sans-serif",
                }}
              >
                Payment Temporarily Unavailable
              </h4>

              {/* Brown divider */}
              <div
                style={{
                  width: "50px",
                  height: "3px",
                  background: "linear-gradient(90deg, #AD7D52, #d5bdaf)",
                  borderRadius: "99px",
                  margin: "0 auto 18px",
                }}
              />

              {/* Message */}
              <p
                style={{
                  color: "#edede9",
                  fontSize: "0.97rem",
                  lineHeight: "1.7",
                  marginBottom: "10px",
                  fontFamily: "'Josefin Sans', sans-serif",
                }}
              >
                Our payment gateway is currently undergoing
                <strong style={{ color: "#d5bdaf" }}> scheduled maintenance</strong>.
                We apologize for the inconvenience.
              </p>
              <p
                style={{
                  color: "rgba(213,189,175,0.6)",
                  fontSize: "0.85rem",
                  marginBottom: "28px",
                  fontFamily: "'Josefin Sans', sans-serif",
                }}
              >
                Please try again after some time. Your cart items are safely saved.
              </p>

              {/* Status badge */}
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  background: "rgba(68,40,46,0.6)",
                  border: "1px solid #ffffffff",
                  borderRadius: "99px",
                  padding: "5px 18px",
                  marginBottom: "28px",
                  fontSize: "0.8rem",
                  color: "#d5bdaf",
                  fontWeight: 600,
                  letterSpacing: "0.5px",
                  fontFamily: "'Josefin Sans', sans-serif",
                }}
              >
                <span
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    background: "#ffffffff",
                    boxShadow: "0 0 7px #ffffffff",
                    animation: "pulseDot 1.4s infinite",
                    display: "inline-block",
                  }}
                />
                Server Under Maintenance
              </div>

              {/* Close Button */}
              <button
                onClick={() => setShowPaymentStoppedPopup(false)}
                style={{
                  display: "block",
                  width: "100%",
                  padding: "13px",
                  borderRadius: "10px",
                  border: "2px solid #ffffffff",
                  background: "#ffffffff",
                  color: "#44282e",
                  fontWeight: 700,
                  fontSize: "0.95rem",
                  cursor: "pointer",
                  letterSpacing: "0.4px",
                  transition: "background 0.2s, color 0.2s, transform 0.15s",
                  fontFamily: "'Josefin Sans', sans-serif",
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = "transparent";
                  e.target.style.color = "#ffffffff";
                  e.target.style.transform = "scale(1.02)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "#ffffffff";
                  e.target.style.color = "#44282e";
                  e.target.style.transform = "scale(1)";
                }}
              >
                Okay, Got It
              </button>

              {/* CSS keyframes */}
              <style>{`
                @keyframes fadeInOverlay {
                  from { opacity: 0; }
                  to   { opacity: 1; }
                }
                @keyframes slideUpPopup {
                  from { opacity: 0; transform: translateY(40px) scale(0.94); }
                  to   { opacity: 1; transform: translateY(0)   scale(1);    }
                }
                @keyframes pulseDot {
                  0%, 100% { transform: scale(1);   opacity: 1; }
                  50%       { transform: scale(1.6); opacity: 0.5; }
                }
              `}</style>
            </div>
          </div>
        )}
        <h1 className="mb-4">Your Cart</h1>
        {Selectedtype === "Health" ? (
          <div className="row">
            <div className="col-12 col-lg-8">
              {consolidatedCartArray.map((item) => (
                <div
                  key={item.orderMainId}
                  className={`card mb-3 cart-item cart-item-${item.orderMainId}`}
                >
                  <div
                    className="card-body d-flex justify-content-between align-items-center"
                    style={{ textAlign: "justify" }}
                  >
                    <div>
                      <h5 className="card-title">{item.type} Booking</h5>
                      <p className="card-text">No Of Guest: {guestNum}</p>
                      <p className="card-text"> Type: {item.type}</p>
                      {item.payload?.BookingDates.length > 0 && (
                        <p className="card-text text-muted">
                          Dates: {item.payload.BookingDates.join(", ")}
                        </p>
                      )}
                    </div>
                    {/* <button
                      onClick={() => handleRemove(item.orderMainId)}
                      className="btn btn-danger"
                    >
                      Remove
                    </button> */}
                  </div>
                </div>
              ))}
            </div>
            <div className="col-12 col-lg-4">
              <div className="card sticky-top" style={{ top: "20px" }}>
                <div className="card-header">Order Summary</div>
                <div className="card-body">
                  <div className="mb-3">
                    <div className="d-flex justify-content-between">
                      <span>Subtotal</span>
                      <span>{formatPrice(totalBookingPrice)}</span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span>Discount</span>
                      <span>{formatPrice(bookingDisAmount)}</span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span>Taxble Value</span>
                      <span>{formatPrice(amountAfterDiscount)}</span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span>GST</span>
                      <span>{formatPrice(totalTaxAmount)}</span>
                    </div>
                    <hr />
                    <div className="d-flex justify-content-between font-weight-bold">
                      <span className="fw-bold">Net Amount</span>
                      <span>{formatPrice(totalNetAmount)}</span>
                    </div>
                  </div>
                  <button
                    onClick={handleEazypayPayment}
                    className="btn btn-warning w-100 mb-2"
                    disabled={loading}
                  >
                    {loading ? "Processing..." : "Pay with Eazypay"}
                  </button>
                  <button
                    onClick={handleClear}
                    className="btn btn-link text-danger"
                  >
                    Clear All Items
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : Selectedtype === "Room" ? (
          <div className="row">
            <div className="col-12 col-lg-8">
              {consolidatedCartArray.map((item) => (
                <div
                  key={item.orderMainId}
                  className={`card mb-3 cart-item cart-item-${item.orderMainId}`}
                >
                  <div
                    className="card-body d-flex justify-content-between align-items-center"
                    style={{ textAlign: "justify" }}
                  >
                    <div>
                      <h5 className="card-title">{item.type} Booking</h5>
                      <p className="card-text ">
                        {/* Base Price: {formatPrice(item.pricing.base)} */}
                        Taxable Value: {formatPrice(item.pricing.roomRate)}
                      </p>
                      <p className="card-text">
                        No Of Guest: {item.details.guests}
                      </p>
                      <p className="card-text"> Type: {item.type}</p>
                      {item.payload?.BookingDates.length > 0 && (
                        <p className="card-text text-muted">
                          Dates:{" "}
                          {item.payload.BookingDates.map((date) =>
                            new Date(date).toLocaleDateString("en-GB"),
                          ).join(", ")}
                        </p>
                      )}
                    </div>
                    {/* <button
                      onClick={() => handleRemove(item.orderMainId)}
                      className="btn btn-danger"
                    >
                      Remove
                    </button> */}
                  </div>
                </div>
              ))}
            </div>
            <div className="col-12 col-lg-4">
              <div className="card sticky-top" style={{ top: "20px" }}>
                <div className="card-header">Order Summary</div>
                <div className="card-body">
                  <div className="mb-3">
                    <div className="d-flex justify-content-between">
                      <span>Subtotal</span>
                      <span>{formatPrice(baseprice)}</span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span>CGST </span>
                      <span>{formatPrice(taxprice / 2)}</span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span>SGST</span>
                      <span>{formatPrice(taxprice / 2)}</span>
                    </div>
                    <hr />
                    {Selectedtype === "Lown" && (
                      <div className="d-flex justify-content-between font-weight-bold">
                        <span>Total</span>
                        <span>{formatPrice(grandTotal)}</span>
                      </div>
                    )}

                    <div className="d-flex justify-content-between font-weight-bold">
                      {Selectedtype === "Lown" ? (
                        <span className="fw-bold">Total Amount</span>
                      ) : (
                        <span className="fw-bold">Net Amount </span>
                      )}
                      <span>{formatPrice(grandTotal)}</span>
                    </div>
                  </div>
                  <button
                    onClick={handleEazypayPayment}
                    className="btn btn-warning w-100 mb-2"
                    disabled={loading}
                  >
                    {loading ? "Processing..." : "Pay with Eazypay"}
                  </button>
                  <button
                    onClick={handleClear}
                    className="btn btn-link text-danger"
                  >
                    Clear All Items
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="row">
            <div className="col-12 col-lg-8">
              {consolidatedCartArray.map((item) => (
                <div
                  key={item.orderMainId}
                  className={`card mb-3 cart-item cart-item-${item.orderMainId}`}
                >
                  <div
                    className="card-body d-flex justify-content-between align-items-center"
                    style={{ textAlign: "justify" }}
                  >
                    <div>
                      <h5 className="card-title">{item.type} Booking</h5>
                      <p className="card-text ">
                        {/* Base Price: {formatPrice(item.pricing.base)} */}
                        Base Price: {formatPrice(item.pricing.base)}
                      </p>
                      <p className="card-text">
                        No Of Guest: {item.details.guests}
                      </p>
                      <p className="card-text"> Type: {item.type}</p>
                      {item.payload?.BookingDates.length > 0 && (
                        <p className="card-text text-muted">
                          Dates:{" "}
                          {item.payload.BookingDates.map((date) =>
                            new Date(date).toLocaleDateString("en-GB"),
                          ).join(", ")}
                        </p>
                      )}
                    </div>
                    {/* <button
                      onClick={() => handleRemove(item.orderMainId)}
                      className="btn btn-danger"
                    >
                      Remove
                    </button> */}
                  </div>
                </div>
              ))}
            </div>
            <div className="col-12 col-lg-4">
              <div className="card sticky-top" style={{ top: "20px" }}>
                <div className="card-header">Order Summary</div>
                <div className="card-body">
                  <div className="mb-3">
                    <div className="d-flex justify-content-between">
                      <span>Subtotal</span>
                      <span>{formatPrice(baseprice)}</span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span>CGST </span>
                      <span>{formatPrice(taxprice / 2)}</span>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span>SGST</span>
                      <span>{formatPrice(taxprice / 2)}</span>
                    </div>
                    <hr />
                    {Selectedtype === "Lown" && (
                      <div className="d-flex justify-content-between font-weight-bold">
                        <span>Total</span>
                        <span>{formatPrice(grandTotal)}</span>
                      </div>
                    )}

                    <div className="d-flex justify-content-between font-weight-bold">
                      {Selectedtype === "Lown" ? (
                        <span className="fw-bold">Total Amount</span>
                      ) : (
                        <span className="fw-bold">Net Amount </span>
                      )}
                      <span>{formatPrice(grandTotal)}</span>
                    </div>
                  </div>
                  <button
                    onClick={handleEazypayPayment}
                    className="btn btn-warning w-100 mb-2"
                    disabled={loading}
                  >
                    {loading ? "Processing..." : "Pay with Eazypay"}
                  </button>
                  <button
                    onClick={handleClear}
                    className="btn btn-link text-danger"
                  >
                    Clear All Items
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
